import { cx } from '@personachat/ui';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { visibleGroups } from './navigation';

export function Sidebar({
  isSuperAdmin,
  collapsed,
  onToggle,
}: {
  isSuperAdmin: boolean;
  collapsed: boolean;
  onToggle: () => void;
}) {
  const groupes = visibleGroups(isSuperAdmin);
  return (
    <nav className={cx('sidebar', collapsed && 'sidebar--collapsed')} aria-label="Navigation principale">
      <div className="sidebar__brand">
        <span className="sidebar__logo" aria-hidden="true">
          M
        </span>
        {!collapsed && (
          <span className="sidebar__brand-text">
            <strong>MyBizGame IA</strong>
            <span>Back-office</span>
          </span>
        )}
      </div>

      <div className="sidebar__groups">
        {groupes.map((groupe) => (
          <div key={groupe.id} className="sidebar__group" data-tour={`nav-${groupe.id}`}>
            {!collapsed && <div className="sidebar__group-label">{groupe.label}</div>}
            <ul>
              {groupe.entries.map((e) => {
                const Icone = e.icon;
                return (
                  <li key={e.id}>
                    <NavLink
                      to={e.path}
                      end={e.path === '/'}
                      className={({ isActive }) => cx('sidebar__link', isActive && 'sidebar__link--active')}
                      title={collapsed ? e.label : undefined}
                      aria-label={collapsed ? e.label : undefined}
                    >
                      <Icone size={16} aria-hidden="true" />
                      {!collapsed && <span>{e.label}</span>}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="sidebar__toggle"
        onClick={onToggle}
        aria-label={collapsed ? 'Déplier la barre latérale' : 'Replier la barre latérale'}
        aria-expanded={!collapsed}
      >
        {collapsed ? <PanelLeftOpen size={16} aria-hidden="true" /> : <PanelLeftClose size={16} aria-hidden="true" />}
        {!collapsed && <span>Replier</span>}
      </button>
    </nav>
  );
}
